import styled from "styled-components";

export const AuthorsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 0.5rem;

  max-height: 15.563rem;
  border-bottom: 1px solid
    ${({ theme }) => theme?.console?.referrals.modalBorderColor};

  h3 {
    color: ${({ theme }) => theme.groups.primaryText} !important;
    font: 500 0.875rem/1.313rem "Inter";
  }

  .authors-list {
    display: flex;
    flex-direction: column;
    max-height: 10rem;
    height: 100%;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-track {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      display: block;
    }
  }
`;

export const SearchInputContainer = styled.div`
  display: flex;
  gap: 1rem;

  position: relative;
  width: 100%;

  :focus-within,
  :has(input.is-filled) {
    input {
      color: ${({ theme }) => theme.colors.searchPage.inputFocusColor};
      background-color: ${({ theme }) =>
        theme.colors.searchPage.inputBackgroundColorHover};
      border: 1px solid #3b82f6;
    }

    svg {
      &.clearInput {
        stroke: ${({ theme }) => theme.colors.searchPage.inputFocusColor};
      }

      path {
        stroke: ${({ theme }) => theme.colors.searchPage.inputFocusColor};
      }
    }
  }

  input,
  svg path {
    transition: 0.3s all;
  }

  input {
    color: ${({ theme }) => theme.colors.searchPage.inputColor};
    font: 400 0.813rem/1.219rem "Inter";

    padding: 0.75rem;
    padding-left: 2.625rem;

    background-color: ${({ theme }) =>
      theme.colors.searchPage.inputBackgroundColor};
    border: 1px solid ${({ theme }) => theme.colors.searchPage.inputBorderColor};

    border-radius: 4px;
    width: 100%;

    @media (max-width: 600px) {
      font: 500 1rem/1.3125rem "Inter";

      padding: 0.75rem;
      padding-left: 2.6rem;

      button {
        top: -1px;
      }
    }

    @media (max-width: 500px) {
      font: 500 0.875rem/1.3125rem "Inter";
    }
  }

  button {
    background: transparent;
    border: none;

    position: absolute;
    left: 0;
    top: 0;

    height: 100%;
    padding: 1rem;

    font-size: 0;

    :disabled {
      pointer-events: none;
    }

    :hover:not(:disabled) {
      cursor: pointer;
      pointer-events: all;
    }

    svg {
      width: 1rem;
      height: 1rem;

      @media (max-width: 600px) {
        width: 1rem;
        height: 1rem;
      }
    }

    @media (max-width: 600px) {
      top: -1px;
    }

    @media (max-width: 500px) {
      top: 0px;
    }
  }

  svg path {
    color: ${({ theme }) => theme.colors.searchPage.inputColor};
  }
`;

export const Empty = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.searchPage.inputFocusColor};

  margin: 3rem 0;
  font: 500 1rem/1.5rem "Inter";

  @media (max-width: 600px) {
    font: 500 0.875rem/1.3125rem "Inter";
  }
`;
